import { render, staticRenderFns } from "./CosmeticTagPage.vue?vue&type=template&id=246c3a9e&scoped=true"
import script from "./CosmeticTagPage.vue?vue&type=script&lang=js"
export * from "./CosmeticTagPage.vue?vue&type=script&lang=js"
import style0 from "./CosmeticTagPage.vue?vue&type=style&index=0&id=246c3a9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c3a9e",
  null
  
)

export default component.exports